import { Box, CircularProgress } from 'components/common';
import { useGetPublicCommunity } from 'core/uses-cases/community';
import { useRouter } from 'hooks';
import { Navigate } from 'navigation';
import { CustomAliasNavigationProps } from 'navigation/alias-redirect';

export const LegacyCommunityUuidExchangeAliasBuilder = ({
	targetRoute,
	params,
}: CustomAliasNavigationProps) => {
	const router = useRouter();
	const { communityId, auth } = params;
	const { data, isError, isLoading } = useGetPublicCommunity(communityId);

	if (isLoading) {
		return (
			<Box display='flex' justifyContent='center' mt={4}>
				<CircularProgress />
			</Box>
		);
	}

	if (isError) {
		return <Navigate to={router.getPathFor('root')} replace />;
	}

	return (
		<Navigate
			to={router.getPathFor(
				targetRoute,
				{
					...params,
					communityId: data?.slug,
				},
				{
					auth,
					communityId: data?.slug,
				}
			)}
			replace
		/>
	);
};
